export { default } from '@shikijs/langs/nginx'
